import { useTranslation } from 'react-i18next'
import {
  SearchAutocomplete,
  SearchAutocompleteOption,
} from '@/components/inputs'

type MonthsMultiSelectProps = {
  value?: string
  onChange: (value: string | undefined) => void
  placeholder?: string
}

export const MonthsMultiSelect = ({
  value,
  onChange,
  placeholder,
}: MonthsMultiSelectProps): JSX.Element => {
  const { t } = useTranslation('expensesDeclaration')

  // Create options for all 12 months
  const options = Array.from({ length: 12 }, (_, i) => {
    const monthNumber = i + 1

    return {
      label: t(`months.${monthNumber}`),
      value: monthNumber.toString(),
    } as SearchAutocompleteOption
  })

  return (
    <SearchAutocomplete
      value={value}
      onChange={onChange}
      options={options}
      placeholder={placeholder || t(`placeholders.month`)}
      sort={false}
      fieldSx={{ width: 280 }}
    />
  )
}
